import { encodeURL, getDateFromParams, getDecodedURL } from 'app/utils/helpers';
import { errorToast } from 'app/utils/toast';
import { ApiBase } from 'app/utils/types/apiTypes';

import { apiCallBack } from '../ApiMethods';
import {
  FileSetsListResponse,
  GetFileSetsListParams,
  InferenceStatusParams,
  InferenceStatusResponse,
} from './types';

export const getWaferMapById: (params: ApiBase<{ id: number }>) => Promise<{
  organization_wafer_id: string;
  meta_info: {
    lot_id: string;
  };
}> = (params: ApiBase<{ id: number }>) => {
  const { id } = params.baseParams;

  return apiCallBack({
    method: 'GET',
    url: `/api/v1/classif-ai/wafer-map/${id}/`,
    ...params,
  }).then(
    _ =>
      _.data as {
        organization_wafer_id: string;
        meta_info: {
          lot_id: string;
        };
      }
  );
};

export const getFileSetsList = (params: ApiBase<GetFileSetsListParams>) => {
  return apiCallBack({
    method: 'GET',
    url: '/api/v1/classif-ai/file-set/',
    ...params,
    transformParams: (baseParams, locationParams) => ({
      ...baseParams,
      ...getDateFromParams(locationParams ?? {}, undefined, true),
    }),
  }).then(_ => _.data as FileSetsListResponse);
};

export const getInferenceStatus = (params: ApiBase<InferenceStatusParams>) => {
  const {
    ml_model_id__in,
    useLocationParams = false,
    ...rest
  } = params.baseParams as unknown as object & {
    ml_model_id__in: string;
    useLocationParams?: boolean;
    upload_session_id__in: string;
  };

  const data = {
    file_set_filters: encodeURL(
      useLocationParams
        ? getDateFromParams(rest, undefined, true)
        : {
            upload_session_id__in: rest.upload_session_id__in,
          }
    ),
    ml_model_id__in,
  };

  return apiCallBack<InferenceStatusParams, unknown, InferenceStatusResponse>({
    method: 'POST',
    url: '/api/v1/classif-ai/file-set-inference-queue/progress_status/',
    ...params,
    data,
    transformParams: () => ({}),
  }).then(_ => _.data);
};

export const getEADefectsTableData: (
  params: ApiBase<{ wafer_id__in: number[]; file_set_filters?: string }>
) => Promise<{
  results: {
    id: number;
    meta_info: Record<string, string | number>;
    wafer_id: number;
    wafer_dot_id: number;
    gt_id: number;
    ai_id: number;
  }[];
} | void> = (
  params: ApiBase<{ wafer_id__in: number[]; file_set_filters?: string }>
) => {
  const { decodedContextual, decodedOther, ...rest } = getDecodedURL(
    window.location.search
  );
  const fileSetFilters = encodeURL(
    getDateFromParams(
      { ...decodedContextual, ...decodedOther, ...rest, ...params.baseParams },
      undefined,
      true
    )
  );
  params.baseParams.file_set_filters = fileSetFilters;
  return apiCallBack({
    method: 'GET',
    url: '/api/v1/classif-ai/file-set/meta-info/',
    ...params,
  })
    .then(
      _ =>
        _.data as {
          results: {
            id: number;
            meta_info: Record<string, string | number>;
            wafer_id: number;
            wafer_dot_id: number;
            gt_id: number;
            ai_id: number;
          }[];
        }
    )
    .catch(e => {
      if (e?.status && e?.message !== 'canceled') {
        errorToast(
          e?.response?.data?.message ||
            e?.response?.message ||
            e?.message ||
            'Something went wrong. Please try again.'
        );
      }
    });
};
